# GraphQL fragment to enable/disable Google calendar email sync
#import "../fragments/user-email-fragment.graphql"

mutation setGoogleMailSendIsEnabled($isEnabled: Boolean!) {
    setGoogleMailSendIsEnabled(input: {mailSync: {isEnabled: $isEnabled}}) {
        authUrl
        emailAddresses {
            ...UserEmail
        }
    }
}
